import { render, staticRenderFns } from "./UPEIBuffersPrelabV2.vue?vue&type=template&id=45a003f6&"
import script from "./UPEIBuffersPrelabV2.vue?vue&type=script&lang=js&"
export * from "./UPEIBuffersPrelabV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports